import { useAtom } from 'jotai';

import userAtom from '@/store/user.store';

import {
  organizationsAtom,
  orgHasEdrProductsAtom,
  orgHasEdrReportsAtom,
  orgHasVmpProductsAtom,
  orgHasVmpReportsAtom,
  selectedOrganizationAtom,
  selectedOrganizationIdAtom
} from '../Organizations';
import {
  allReportsAtom,
  edrReportsAtom,
  executiveReportsAtom,
  filteredReportsAtom,
  mdrReportsAtom,
  reportsAtom,
  reportsFiltersAtom,
  useCreateReport,
  useDeleteReport,
  useFetchAllReports,
  useFetchReports,
  useUpdateReport,
  vmpReportsAtom
} from './Reports.store';

const useReports = () => {
  const [selectedOrganizationId] = useAtom(selectedOrganizationIdAtom);
  const [user] = useAtom(userAtom);
  const [selectedOrganization] = useAtom(selectedOrganizationAtom);
  const [reportsFilters, setReportsFilters] = useAtom(reportsFiltersAtom);
  const [filteredReports] = useAtom(filteredReportsAtom);
  const [organizations] = useAtom(organizationsAtom);

  const [mdrReports] = useAtom(mdrReportsAtom);
  const [executiveReports] = useAtom(executiveReportsAtom);
  const [vmpReports] = useAtom(vmpReportsAtom);
  const [edrReports] = useAtom(edrReportsAtom);
  const [reports] = useAtom(reportsAtom);
  const [allReports] = useAtom(allReportsAtom);
  const [orgHasEdrProducts] = useAtom(orgHasEdrProductsAtom);
  const [orgHasEdrReports] = useAtom(orgHasEdrReportsAtom);
  const [orgHasVmpProducts] = useAtom(orgHasVmpProductsAtom);
  const [orgHasVmpReports] = useAtom(orgHasVmpReportsAtom);

  const { refetch } = useFetchReports();
  const { refetch: refetchAll } = useFetchAllReports(); // Fetch all reports, only used when user is internal and org is set to "All Organizations"

  const {
    mutate: createReport,
    isSuccess: createSuccess,
    error: createError
  } = useCreateReport(refetch, refetchAll);

  const { mutate: deleteReport } = useDeleteReport(refetch, refetchAll);

  const { mutate: updateReport } = useUpdateReport(refetch, refetchAll);

  return {
    mdrReports,
    executiveReports,
    vmpReports,
    edrReports,
    deleteReport,
    createReport,
    updateReport,
    selectedOrganizationId,
    createSuccess,
    reports,
    user,
    selectedOrganization,
    reportsFilters,
    setReportsFilters,
    filteredReports,
    allReports,
    createError,
    organizations,
    orgHasEdrProducts,
    orgHasEdrReports,
    orgHasVmpProducts,
    orgHasVmpReports
  };
};

export default useReports;
